import { IBrazeCustomEventLog, IBrazePurchaseEventLog } from '~/app/braze/brazeCustomLog'
import { isNative } from '~/app/utils/typeguards'
import { getYaNative } from '@yanolja-org/ya-native'

let isRoleUser = false

/**
 * @note @yanolja-rnd/ya-tracker BrazeTracker 에 sendPurchaseEvent 가 없어 사용 불가(23.05.04)
 */
export const Braze = {
  /**
   * @desc  비회원 구분을 위해 isRoleUser 초기화
   * */
  initialize(_isRoleUser) {
    isRoleUser = _isRoleUser
  },

  /**
   * 정의된 커스텀 이벤트를 전송하는 메소드 (only 회원)
   * @link {https://docs.google.com/spreadsheets/d/1iJdrTz1HPMxbPx7Au9SSv6S6DZas32ZbnFzEy0WtbMk/edit#gid=1308376500}
   * @param eventName
   * @param data
   */
  sendCustomEvent(eventName: string, data: IBrazeCustomEventLog) {
    if (typeof window === 'undefined' || !isRoleUser) {
      return
    }

    if (process.env.NODE_ENV === 'development') {
      console.table({ eventName, ...data })
    }

    const yaNative = getYaNative()
    if (isNative(yaNative)) {
      // 필요시 시스템 데이터추가
      const eventProperties = Object.assign({}, data)
      yaNative.braze({ eventName, ...eventProperties }, () => null)
    }
  },

  /**
   * Braze SDK의 구매 이벤트 로그 전송 (only 회원)
   * @link {https://www.braze.com/docs/developer_guide/platform_integration_guides/web/analytics/logging_purchases/}
   * @param data
   */
  sendPurchaseEvent(data: IBrazePurchaseEventLog | null) {
    if (typeof window === 'undefined' || !isRoleUser) {
      return
    }

    if (process.env.NODE_ENV === 'development') {
      console.table(data)
    }
    const yaNative = getYaNative()
    if (isNative(yaNative) && data !== null) {
      // 필요시 시스템 데이터추가
      const eventProperties = Object.assign({}, data)
      // 야놀자 앱에서 braze 로그 전송
      yaNative.brazeLogPurchase(eventProperties, () => null)
    }
  },
}
